module.exports = __webpack_public_path__ + "static/media/auchan1.a7f3c07f.jpg";